import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/system/Stack";
import Typography from "@mui/material/Typography";
const ContactTemplate = (props) => {
    const { page } = props;
    const { contents } = page;
    const { contactForm, dynamicPart, addressTitle, dynamicLocationPart } = contents;
    return (_jsxs(Container, { sx: { maxWidth: "1208px !important", py: { xs: "40px", md: "64px" } }, children: [_jsxs(Stack, { direction: { xs: "column", md: "row" }, spacing: 5, children: [_jsx(Stack, { sx: {
                            backgroundColor: "#F0F0F4",
                            padding: { xs: 3, md: 5 },
                            width: "100%",
                        }, children: contactForm }), _jsxs(Stack, { spacing: 2, sx: {
                            backgroundColor: "#FFFF80",
                            padding: { xs: 3, md: 5 },
                            minWidth: { xs: "100%", md: "400px", lg: "460px" },
                            maxWidth: "100%",
                            height: "max-content",
                        }, children: [_jsx(Typography, { component: "h2", variant: "subtitle1", sx: {
                                    fontSize: "18px",
                                }, children: addressTitle }), _jsx(Box, { children: dynamicLocationPart })] })] }), _jsx(Box, { children: dynamicPart })] }));
};
export default ContactTemplate;
